<template>
	<div style="background-color: white; height: 100%">
		<v-simple-table>
			<template v-slot:default>
				<thead v-if="ubicación">
					<tr>
						<th class="text-center" :colspan="pedidos.length"><h1>Pedidos para {{ ubicación.nombre }}</h1></th>
					</tr>
				</thead>
				<tbody ssstyle="pointer-events: none">
					<tr>
						<td style="min-width: 300px; padding: 20px; vertical-align: top" v-for="(p, i) in pedidos" :key="`p${i}`">
							<pedido-resumen :pedido="p" @modificar="modificar" @cancelarPedidoNoOrdenado="cancelarPedidoNoOrdenado(i)"></pedido-resumen>
						</td>
					</tr>
				</tbody>
			</template>
		</v-simple-table>

	</div>
</template>

<script>
import PedidoResumen from './Pedido_Resumen';

export default {
	name: 'PedidosResumen',
	data: () => ({
		//
	}),
	components: {
		PedidoResumen
	},
	props: ['pedidos', 'ubicación'],
	methods: {
		cancelarPedidoNoOrdenado: function (i) {
			this.pedidos.splice(i, 1)
		},
		modificar: function(v) {
			this.$emit('modificar', v)
		},
	}
}
</script>

<style scoped>

 tr:hover {
     background-color: white !important;
 }

</style>